const { default: config } = require("utils/config");

const useCheckSignupPause = () => {
    const now = new Date();
    const startTime = new Date('2026-04-10T00:00:00+08:00');
    const endTime = new Date(config.PLATFORM_MAINTENANCE_END_TIME);

    if (now < startTime || now > endTime) {
        return false;
    }

    return true;
}

export default useCheckSignupPause;